var blue = {
  50: '#AAEFFF',
  100: '#55DAFF',

  /* Light FluidBlue */
  200: '#1BCCFD',

  /* FluidBlue Hover */
  300: '#0094C9',

  /* ADA Blue 3:45:1 */
  400: '#007EB0',

  /* ADA Blue 4.55:1 */
  500: '#00B2E3',

  /* FluidBlue */
  600: '#1758A0',

  /* Dark Mode Light Hover */
  700: '#005885',

  /* Dark Mode Light */
  800: '#003D61',

  /* Dark Mode Medium */
  900: '#001A29'
  /* Dark Mode Dark */

};
var gray = {
  50: '#F7F7F7',

  /* Lightest Gray */
  100: '#F2F2F2',

  /* Light Gray */
  200: '#E5E5E5',

  /* Component Gray */
  300: '#D4D4D4',

  /* Keylines Gray */
  400: '#CCCCCC',

  /* 253 Keylines Gray? */
  500: '#A7B2BB',

  /* Fluid Gray */
  600: '#B0B3B5',

  /* Silver */
  700: '#949494',

  /* ADA Gray 3:1 */
  800: '#8F8F8F',

  /* Secondary Gray */
  900: '#666666'
  /* Dark Gray */

};
var red = {
  50: '#ffe1e1',
  100: '#ffb1b1',
  200: '#FF5A5F',

  /* Dark Mode */
  300: '#f44336',

  /* EV Red */
  400: '#EB5757',

  /* Fleetview Brake Red */
  500: '#DA0000',

  /* Error */
  600: '#b40000',
  700: '#810000',
  800: '#500000',
  900: '#210000'
};
var orange = {
  50: '#fff4db',
  100: '#ffe2ad',
  200: '#ffce7d',
  300: '#febb4b',
  400: '#F2994A',

  /* Fleetview HardCorner Orange */
  500: '#E28C01',

  /* Warning Battery */
  600: '#A4783E',

  /* Driver Cup Bronze */
  700: '#cb7e00',
  800: '#803e00',
  900: '#4d1f00'
};
var green = {
  50: '#aeffcf',
  100: '#7effb6',
  200: '#3ED284',

  /* Dark Mode */
  300: '#22ff8e',
  400: '#0ee67c',
  500: '#00AB61',

  /* Success */
  600: '#00803f',
  700: '#004e1f',

  /* 4.5:1 Green */
  800: '#001c04',
  900: '#001c04'
};
var yellow = {
  50: '#FFFFF0',
  100: '#FEFCBF',
  200: '#FAF089',
  300: '#F6E05E',
  400: '#FFCD00',

  /* FleetView Private Yellow */
  500: '#D69E2E',
  600: '#C5A85E',

  /* Driver Cup Gold */
  700: '#975A16',
  800: '#744210',
  900: '#5F370E'
};
var purple = {
  50: '#FAF5FF',
  100: '#E9D8FD',
  200: '#D6BCFA',
  300: '#B794F4',
  400: '#9F7AEA',
  500: '#9B51E0',

  /* FleetView OverAccelerate Purple */
  600: '#6B46C1',
  700: '#553C9A',
  800: '#44337A',
  900: '#322659'
};
var brand = {
  50: '#FFF0D1',
  // papaya
  100: '#ffe6ad',
  200: '#ffd57d',
  300: '#ffc44b',
  400: '#ffb31a',
  500: '#FFAC06',
  // cheese
  600: '#b37700',
  700: '#815500',
  800: '#4e3300',
  900: '#1e1000'
};
var colors = {
  // Common Colors
  transparent: 'transparent',
  currentColor: 'currentColor',
  black: '#2D333A',
  white: '#FFFFFF',
  // Color Overrides
  blue: blue,
  cyan: blue,
  orange: orange,
  red: red,
  green: green,
  gray: gray,
  yellow: yellow,
  purple: purple,
  brand,
  cheese: brand['500'],
  papaya: brand['50']
};
export default colors;
//# sourceMappingURL=colors.js.map